import { cn } from './cn';
import { Spinner } from './Spinner';

/**
 * Waiting for a page's data: the ring the product turns, centred in the space
 * the content will take, and announced to a screen reader.
 */
export function LoadingState({
  label = 'Loading',
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <div className={cn('flex min-h-64 items-center justify-center', className)}>
      <Spinner label={label} />
    </div>
  );
}
